/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { IAccordionExpandedState } from './data-actions/accordion-state';
import { createAccordionStateInput } from './data-actions/accordion-state-data-action';
import accordion from './modules/accordion/accordion';
import { interactionStyle } from './modules/accordion/accordion.props.autogenerated';
import accordionView from './modules/accordion/accordion.view';

export * from './modules/accordion/accordion';
export * from './modules/accordion/accordion.view';

export {
    accordion,
    accordionView,
    createAccordionStateInput,
    IAccordionExpandedState,
    interactionStyle
};
